import React from 'react';
import {Link} from "react-router-dom";
import {Checkbox, Col, Row} from "react-bootstrap";

import Objects from "../utils/Objects";
import BalanceService from "./BalanceService";
import EPCLink from "../component/Asset/EPCLink";
import {dayMonthYearAtTime} from "../utils/dates";
import DispositionSelector from "../disposition/DispositionSelector";
import BizStepSelector from "../component/BizStep/BizStepSelector";
import ProductTypeSelector from "../productType/component/ProductTypeSelector";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector";
import {BalanceStorage} from "./BalanceStorage";

export default class BalanceByAssetGrid {

  constructor(props) {
    this.state = {
      itemsSelected: [],
      allItems: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.selectAll = this.selectAll.bind(this)
  }

  title = "Saldo atual de produtos";
  exportNewPage = true;

  showNewButton = false;

  refreshState = null;
  storage = new BalanceStorage();

  customFilters = {
    dispositionId: this.storage.getDispositions(),
    bizStepId: this.storage.getBizSteps(),
    productTypeId: this.storage.getProductTypes(),
    productTypeByAsset: this.storage.getProductTypesByAsset(),
    bizLocationId: this.storage.getBizLocation()
  }
  onData(data) {
    this.state.allItems = data.content
    this.refreshState && this.refreshState()
  }

  customFilterComponent = (props, state, onChange) => {
    return (
      <div>
        <Row>
          <Col md={3}>
            <BizLocationSelector
              multiple
              defaultValue={props.match.params.bizLocationId}
              setValue={value => {
                this.customFilters.bizLocationId = value.map(x => x.id);
                onChange(this.customFilters);
              }}/>
          </Col>
          <Col md={3}>
            <ProductTypeSelector
              multiple
              defaultValue={props.match.params.productTypeId}
              setValue={value => {
                this.customFilters.productTypeByAsset = value.map(x => x.id);
                onChange(this.customFilters);
              }}/>
          </Col>
          <Col md={3}>
            <DispositionSelector
              multiple
              defaultValue={this.customFilters.dispositionId}
              setValue={value => {
                this.customFilters.dispositionId = value.map(x => x.id);
                onChange(this.customFilters);
              }}/>
          </Col>
          <Col md={3}>
            <BizStepSelector
              multiple
              defaultValue={this.customFilters.bizStepId}
              setValue={value => {
                this.customFilters.bizStepId = value.map(x => x.id);
                onChange(this.customFilters);
              }}/>
          </Col>
        </Row>
      </div>
    )
  };

  customHeader = (props, state, onChange, refreshState) => {
    this.refreshState = refreshState;
    const listAssetsChecked = state.metadata.getSelectedItems();
    const link = '/transactions/new/';
    return (
      <Link to={{
        pathname: link,
        aboutProps: {
          listAssetsChecked: listAssetsChecked,
        }
      }}>
        <button className="btn btn-info pull-right"
                disabled={state.metadata.getSelectedItems().length === 0}
                title="Movimentação Manual">
          Movimentação Manual
        </button>
      </Link>
    )
  };

  selectAll() {
    if (this.state.itemsSelected.length > 0) {
      this.state.itemsSelected = []
    } else {
      this.state.itemsSelected = this.state.allItems.map(x => x.id)
    }
    this.refreshState && this.refreshState();
  };

  handleChange(assetId) {
    const itemExists = this.state.itemsSelected.includes(assetId)
    if (itemExists) {
      this.state.itemsSelected = this.state.itemsSelected.filter(x => x !== assetId)
    } else {
      this.state.itemsSelected.push(assetId);
    }

    this.refreshState && this.refreshState();
  }

  getSelectedItems() {
    return this.state.itemsSelected.map(y => {
      const item = this.state.allItems.find(x => x.id === y)
      return item
    });
  }

  columns = [
    {
      Header: (
        <Checkbox
          onChange={() => this.selectAll()}
          disabled={false}
        />
      ),
      minWidth: 35,
      export: false,
      sortable: false,
      Cell: (props, state) => <Checkbox
        onChange={() => this.handleChange(props.original.id)}
        checked={this.state.itemsSelected.includes(props.original.id)}
      />

    },
    {
      Header: "EPC",
      accessor: "tags.value",
      Cell: (props) => {
        const {epc, tags} = props.original;
        if (tags && tags.length > 0) {
          return tags.map(x => <p key={x.value}><EPCLink epc={x}/></p>);
        }
        return (<EPCLink epc={epc}/>);
      }
    },
    {
      Header: "Nome",
      accessor: "productType.friendlyName"
    },
    {
      Header: "Referência",
      accessor: "productType.reference"
    },
    {
      Header: "Localização Atual",
      accessor: "currentState.lsd.bizLocation.friendlyName"
    },
    {
      Header: "Disposição Atual",
      accessor: "currentState.lsd.disposition.friendlyName"
    },
    {
      Header: "Etapa Atual",
      accessor: "currentState.lsd.bizStep.friendlyName"
    },
    {
      Header: "Código do lote",
      accessor: "lot.code"
    },
    {
      Header: "Data",
      accessor: "currentState.stateDate",
      isDate: true,
      Cell: (props) => dayMonthYearAtTime(props.original.currentState.stateDate)
    }
  ];

  endpoint = () => {
    const params = new URLSearchParams({});

    this.customFilters.bizLocationId && params.append('bizLocationIds', this.customFilters.bizLocationId);

    this.customFilters.productTypeByAsset && params.append('productTypeIds', this.customFilters.productTypeByAsset);

    this.customFilters.dispositionId && params.append('dispositionIds', this.customFilters.dispositionId);

    this.customFilters.bizStepId && params.append('bizStepIds', this.customFilters.bizStepId);

    return `${BalanceService.ASSET_URL}?${params.toString()}`;
  }

}



// WEBPACK FOOTER //
// ./src/balance/BalanceByAssetGrid.js